import { TZ } from  '@/utils/intl.js';
import { format, getISO } from '@/utils/time.js';

export default range => {
  const { start, end } = range || {};
  if (!start)
    return null;
  if (!end || (start == end))
    return format(getISO(start, '00:00', TZ), 'long-month-date-ordinal');
  const monthStart = format(getISO(start, '00:00', TZ), 'long-month');
  const monthEnd = format(getISO(end, '00:00', TZ), 'long-month');
  const dateStart = format(getISO(start, '00:00', TZ), 'date-ordinal');
  const dateEnd = format(getISO(end, '00:00', TZ), 'date-ordinal');
  if (monthStart == monthEnd)
    return `${monthStart} ${dateStart} – ${dateEnd}`;
  return `${monthStart} ${dateStart} – ${monthEnd} ${dateEnd}`;
};
